export default function BhanwarkuaHostel() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-10 text-gray-800">

      <h1 className="text-3xl font-bold mb-6">
        Best Girls Hostel in Bhanwarkua Indore
      </h1>

      <p className="mb-4">
        Looking for the best girls hostel in Bhanwarkua Indore? Shri Ji Girls Hostel offers a safe,
        clean and comfortable living space for students and working women near DAVV.
      </p>

      <p className="mb-4">
        Shri Ji Girls Hostel is one of the most preferred options for students searching for girls hostel in Bhanwarkua Indore due to its location and facilities.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">
        Why Choose Shri Ji Girls Hostel?
      </h2>

      <ul className="list-disc ml-5 space-y-2">
        <li>Safe environment with CCTV</li>
        <li>Home-style food available</li>
        <li>High-speed WiFi</li>
        <li>Daily cleaning and hygiene</li>
        <li>Walking distance from DAVV</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">
        Location Advantage
      </h2>

      <p className="mb-4">
        Located in Bhanwarkua, Indore near DAVV and coaching institutes.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">
        Book Your Stay Today
      </h2>

      <a
        href="https://wa.me/917049747730"
        className="bg-green-500 text-white px-6 py-3 rounded-lg inline-block"
      >
        Contact on WhatsApp
      </a>

      <p className="mt-6">
        Check our <a href="/rooms" className="text-pink-600 underline">available rooms</a> or 
        <a href="/contact" className="text-pink-600 underline ml-1">contact us</a>.
      </p>

    </div>
  );
}
